module.exports = __webpack_public_path__ + "f7d898408f4d024dd9bed5b031da0c56.MP3";